export const Storage = {
  setItem(name: string, data: any) {
    return localStorage.setItem(name, JSON.stringify(data));
  },
  getItem(name: string) {
    const item = localStorage.getItem(name);
    return item ? JSON.parse(item) : null;
  },
  removeItem(name: string) {
    localStorage.removeItem(name);
  },
};
